export const isLoggedIn = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  return userData || null;
};

export function setLoggedUser(data) {
  localStorage.setItem('userData', JSON.stringify(data));
}

export function setLoggedUserToken(data) {
  localStorage.setItem('token', data);
}

export function loggedOutUser() {
  localStorage.removeItem('userData');
  localStorage.removeItem('token');
}

export const userAuth = () => {
  const token = localStorage.getItem('token');
  const user = isLoggedIn();
  if (token && user) {
    return true;
  } else {
    return false;
  }
};

export const getToken = () => {
  const token = localStorage.getItem('token');
  if (token) {
    return token;
  } else {
    return null;
  }
};